import MessagingModal from "./MessagingModal";

export default MessagingModal;